module.exports = function getResource(label, vars = []) {
    let resources = {
        relevancy: 'Relevancy',
        bestselling: 'Bestselling',
        topRated: 'Top Rated',
        exclusive: 'Exclusive',
        new: 'New',
        priceDesc: 'Price High to Low',
        priceAsc: 'Price Low to High',
        brandName: 'Brand Name'
    };

    return resources[label];
};
